export enum RemoteControlModel {
  VR91 = 'VR91',
  VR91F = 'VR91F',
  VR92 = 'VR92',
  VR92F = 'VR92F',
}
